import { Fragment } from 'react';
import { YStack } from '../Containers/Stacks/YStack';
import { Text } from '../Texts/Text';

export type Step<TStepId extends string = string> = {
  id: TStepId;
  label: string;
};

export type StepIndicatorProps<TStepId extends string = string> = {
  allCompleted?: boolean;
  currentStep: TStepId;
  steps: readonly Step<TStepId>[];
};

const STEP_CIRCLE_SIZE = 16;

export const StepIndicator = <TStepId extends string>({
  allCompleted,
  currentStep,
  steps,
}: StepIndicatorProps<TStepId>) => {
  const currentStepIndex = steps.findIndex((step) => step.id === currentStep);
  const gridTemplateColumns = steps.map((_, index) => (index < steps.length - 1 ? 'auto 1fr' : 'auto')).join(' ');

  return (
    <div className="w-full">
      <div className="grid w-full items-center" style={{ gridTemplateColumns }}>
        {steps.map((step, index) => {
          const isCompleted = allCompleted ?? index < currentStepIndex;
          const isCurrent = index === currentStepIndex;
          const isLastStep = index === steps.length - 1;

          return (
            <Fragment key={step.id}>
              <YStack alignItems="center" gapY="xs">
                <div
                  className={`rounded-full ${
                    isCompleted || isCurrent ? 'bg-neutral-950' : 'border-2 border-neutral-950 bg-white'
                  }`}
                  style={{ height: STEP_CIRCLE_SIZE, width: STEP_CIRCLE_SIZE }}
                />
                <Text color="primary" textAlign="center" type="p-sm">
                  {step.label}
                </Text>
              </YStack>

              {!isLastStep ? (
                <div className="mb-auto" style={{ marginTop: STEP_CIRCLE_SIZE / 2 }}>
                  {isCompleted ? (
                    <div className="w-full bg-neutral-950" style={{ height: 1 }} />
                  ) : (
                    <div className="w-full border-t border-dashed border-neutral-950" style={{ height: 0 }} />
                  )}
                </div>
              ) : null}
            </Fragment>
          );
        })}
      </div>
    </div>
  );
};
